import axiosInstance from "./axiosService";
import serverUrl from "../config/serverUrl.js";

const API_URL = serverUrl;

// const token = localStorage.getItem('token');

export const fetchAddress = async () => {
  const response = await axiosInstance.get(`${API_URL}/address`);
  return response.data;
};

export const addAddress = async (formData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/address`, formData);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const removeAddress = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/address/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error.response.data;
  }
};
